import { FiLock } from 'react-icons/fi'

/**
 * «فقط مدیران می‌بینند» — shown wherever the managers' vote appears.
 *
 * The owner asked for it (2026-09-11) so a manager knows the member is not
 * reading over their shoulder, and does not hold back a «مخالفم» for fear of
 * it. The promise is true on every client: the server never sends the vote to
 * anyone but a manager, so this is a statement of fact, not of intent.
 */
export default function ManagersOnly({
    className = '',
    compact = false,
}: {
    className?: string
    /** icon only, for a row with no room — still labelled for screen readers */
    compact?: boolean
}) {
    return (
        <span
            title="فقط مدیران می‌بینند"
            aria-label={compact ? 'فقط مدیران می‌بینند' : undefined}
            className={` inline-flex shrink-0 items-center gap-1 rounded-full bg-canvas px-2 py-0.5 text-[10px] font-normal text-text-secondary ${className}`}
        >
            <FiLock size={10} aria-hidden />
            {!compact && 'فقط مدیران می‌بینند'}
        </span>
    )
}
